import { ContentNode, EmiRequest } from 'models'
import nodeIds from '../config/nodeIds'
import Constants from 'api-constants'

const emiRequests = Constants.emiRequests
const {
    DEFAULT_COACH_CONTINUE_WATCHING_MOVIES,
    DEFAULT_COACH_CONTINUE_WATCHING_TVSHOWS,
    DEFAULT_COACH_GET_LIVE_NOW_ALL,
    DEFAULT_COACH_RECOMMENDED_MOVIES,
    DEFAULT_COACH_RECOMMENDED_SERIES_PORTRAIT,
    DEFAULT_COACH_RECOMMENDED_SERIES_LANDSCAPE,
    DEFAULT_COACH_RECOMMENDED_SERIES_HYBRID,
    DEFAULT_DYNAMIC_RECOMMENDATION,
    DEFAULT_DYNAMIC_RECOMMENDATION_1,
    DEFAULT_DYNAMIC_RECOMMENDATION_2,
    DEFAULT_DYNAMIC_RECOMMENDATION_3,
    DEFAULT_DYNAMIC_RECOMMENDATION_4,
    DEFAULT_DYNAMIC_RECOMMENDATION_5,
    DEFAULT_DYNAMIC_RECOMMENDATION_6,
    DEFAULT_DYNAMIC_RECOMMENDATION_7,
    DEFAULT_DYNAMIC_RECOMMENDATION_8,
    DEFAULT_DYNAMIC_RECOMMENDATION_9,
    DEFAULT_DYNAMIC_RECOMMENDATION_10,
    DEFAULT_DYNAMIC_RECOMMENDATION_11,
    DEFAULT_DYNAMIC_RECOMMENDATION_12,
    DEFAULT_DYNAMIC_RECOMMENDATION_13,
    DEFAULT_DYNAMIC_RECOMMENDATION_14,
    DEFAULT_DYNAMIC_RECOMMENDATION_15,
    DEFAULT_DYNAMIC_RECOMMENDATION_16,
    DEFAULT_DYNAMIC_RECOMMENDATION_17,
    DEFAULT_DYNAMIC_RECOMMENDATION_18,
    DEFAULT_DYNAMIC_RECOMMENDATION_19,
    DEFAULT_DYNAMIC_RECOMMENDATION_20,
} = Constants.requestIds

export default {
    programmingId: 0,
    navMap: {
        [nodeIds.home]: new ContentNode({
            id: nodeIds.home,
            labels: { default: 'Home' },
            intlKey: { tag: nodeIds.home },
            translateLabel: true,
            parent: nodeIds.root,
            body: {
                type: 'list',
                data: [
                    DEFAULT_COACH_CONTINUE_WATCHING_MOVIES,
                    DEFAULT_COACH_CONTINUE_WATCHING_TVSHOWS,
                    DEFAULT_COACH_GET_LIVE_NOW_ALL,
                    DEFAULT_COACH_RECOMMENDED_MOVIES,
                    DEFAULT_COACH_RECOMMENDED_SERIES_PORTRAIT,
                    DEFAULT_COACH_RECOMMENDED_SERIES_LANDSCAPE,
                    DEFAULT_COACH_RECOMMENDED_SERIES_HYBRID,
                    DEFAULT_DYNAMIC_RECOMMENDATION,
                    DEFAULT_DYNAMIC_RECOMMENDATION_1,
                    DEFAULT_DYNAMIC_RECOMMENDATION_2,
                    DEFAULT_DYNAMIC_RECOMMENDATION_3,
                    DEFAULT_DYNAMIC_RECOMMENDATION_4,
                    DEFAULT_DYNAMIC_RECOMMENDATION_5,
                    DEFAULT_DYNAMIC_RECOMMENDATION_6,
                    DEFAULT_DYNAMIC_RECOMMENDATION_7,
                    DEFAULT_DYNAMIC_RECOMMENDATION_8,
                    DEFAULT_DYNAMIC_RECOMMENDATION_9,
                    DEFAULT_DYNAMIC_RECOMMENDATION_10,
                    DEFAULT_DYNAMIC_RECOMMENDATION_11,
                    DEFAULT_DYNAMIC_RECOMMENDATION_12,
                    DEFAULT_DYNAMIC_RECOMMENDATION_13,
                    DEFAULT_DYNAMIC_RECOMMENDATION_14,
                    DEFAULT_DYNAMIC_RECOMMENDATION_15,
                    DEFAULT_DYNAMIC_RECOMMENDATION_16,
                    DEFAULT_DYNAMIC_RECOMMENDATION_17,
                    DEFAULT_DYNAMIC_RECOMMENDATION_18,
                    DEFAULT_DYNAMIC_RECOMMENDATION_19,
                    DEFAULT_DYNAMIC_RECOMMENDATION_20,
                ].map((id) => ({ id })),
            },
            highlight: { data: [] },
            // no PPZ for now as it's too unpredictable
            // 200 channels => 200 tiles in the PPZ, if we decide to display live now programs.
            // If we use a VOD pre-request (e.g favourites, continue watching) the thumbnails don't match any of
            // the PPZ tile formats (duo, tertio, quattro formaggi etc...)
        }),
    },
    requestMap: {
        [DEFAULT_COACH_CONTINUE_WATCHING_MOVIES]: new EmiRequest({
            id: DEFAULT_COACH_CONTINUE_WATCHING_MOVIES,
            value: emiRequests.CONTINUE_WATCHING_VOD_MOVIES,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_CONTINUE_WATCHING_MOVIES },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_DYNAMIC_RECOMMENDATION]: new EmiRequest({
            id: DEFAULT_DYNAMIC_RECOMMENDATION,
            value: emiRequests.GET_DYNAMIC_RECOMMENDATION,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_DYNAMIC_RECOMMENDATION },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_DYNAMIC_RECOMMENDATION]: new EmiRequest({
            id: DEFAULT_DYNAMIC_RECOMMENDATION_1,
            value: emiRequests.DEFAULT_DYNAMIC_RECOMMENDATION_1,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_DYNAMIC_RECOMMENDATION_1 },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_CONTINUE_WATCHING_TVSHOWS]: new EmiRequest({
            id: DEFAULT_COACH_CONTINUE_WATCHING_TVSHOWS,
            value: emiRequests.CONTINUE_WATCHING_VOD_TVSHOWS,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_CONTINUE_WATCHING_TVSHOWS },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_GET_LIVE_NOW_ALL]: new EmiRequest({
            id: DEFAULT_COACH_GET_LIVE_NOW_ALL,
            value: emiRequests.GET_LIVE_NOW_ALL,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_GET_LIVE_NOW_ALL },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_RECOMMENDED_MOVIES]: new EmiRequest({
            id: DEFAULT_COACH_RECOMMENDED_MOVIES,
            value: emiRequests.GET_MOVIES_RECOMMENDATION,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_RECOMMENDED_MOVIES },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_RECOMMENDED_SERIES_PORTRAIT]: new EmiRequest({
            id: DEFAULT_COACH_RECOMMENDED_SERIES_PORTRAIT,
            value: emiRequests.GET_SERIES_RECOMMENDATION_PORTRAIT,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_RECOMMENDED_SERIES_PORTRAIT },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_RECOMMENDED_SERIES_LANDSCAPE]: new EmiRequest({
            id: DEFAULT_COACH_RECOMMENDED_SERIES_LANDSCAPE,
            value: emiRequests.GET_SERIES_RECOMMENDATION_LANDSCAPE,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_RECOMMENDED_SERIES_LANDSCAPE },
            translateLabel: true,
            args: [],
        }),
        [DEFAULT_COACH_RECOMMENDED_SERIES_HYBRID]: new EmiRequest({
            id: DEFAULT_COACH_RECOMMENDED_SERIES_HYBRID,
            value: emiRequests.GET_SERIES_RECOMMENDATION_HYBRID,
            labels: { default: '' },
            intlKey: { tag: DEFAULT_COACH_RECOMMENDED_SERIES_HYBRID },
            translateLabel: true,
            args: [],
        }),
    },
}
